import { ValidationError } from "../../errors/validation-error";
import { MailRequest } from "./mail-request";
import { MailValidator } from "./validators/mail-validator";

/**
 * A request for sending e-mails to all users.
 */
export class MailRequestBroadcast extends MailRequest {
    validate(): void {
        const failures = new MailValidator().validate(this);
        if (failures.length > 0) {
            throw new ValidationError(`MailRequestBroadcast is invalid`);
        }
    }
}
